
<div class="sticky-toolbar mb-8 text-[14px]">
    <p-toolbar class="text-[14px] p-0">
    <ng-template #start>
        <button pButton type="button" icon="pi pi-print" [label]="isPreviewMode ? 'Print Preview' : 'Print'" class="p-button-sm p-button-secondary" (click)="printInvoice()"></button>
        <button *ngIf="isPreviewMode && isFromSyncFlow && !viewOnly" pButton type="button" icon="pi pi-cloud-upload" label="Sync to M3" 
        class="p-button-sm p-button-secondary ml-2" (click)="confirmSyncToM3()"></button>
<button *ngIf="isPreviewMode && !isFromSyncFlow && !viewOnly" pButton type="button" icon="pi pi-check" label="Confirm & Invoice" 
        class="p-button-sm p-button-secondary ml-2" (click)="confirmAndInvoice()"></button>
        <!-- Show Go to Order button only in preview mode -->
        <button *ngIf="isPreviewMode && !viewOnly" pButton type="button" icon="pi pi-pencil" label="Go to Order" 
                class="p-button-sm p-button-secondary ml-2" (click)="goToOrder()"></button>
        <button *ngIf="isPreviewMode" pButton type="button" icon="pi pi-envelope" label="Send preview on mail" 
                class="p-button-sm p-button-secondary ml-2" (click)="openSendPreviewMailDialog()"></button>
        <div style="display: inline-block; margin-left: 16px">
            <label for="languageSelect" style="margin-right: 8px">Language:</label>
            <select id="languageSelect" [(ngModel)]="selectedLanguage" (ngModelChange)="onLanguageChange($event)">
                <option value="en">English</option>
                <option value="de">German</option>
                <option value="nl">Dutch</option>
                <option value="fr">French</option>
            </select>
        </div>
    </ng-template>
    <ng-template #end>
        <button pButton type="button" icon="pi pi-arrow-left" label="Back" class="p-button-sm p-button-secondary ml-2" (click)="goBack()"></button>
    </ng-template>
</p-toolbar>
</div>

<p-dialog [(visible)]="confirmInvoiceDialogVisible" [style]="{ width: '400px' }" header="Confirm Invoice" [modal]="true">
<ng-template pTemplate="content">
    <div class="text-center">
        <p>
            Printing invoice will change the order status to <b>INV</b>.<br />
            Are you sure you want to continue?
        </p>
    </div>
</ng-template>
<ng-template pTemplate="footer">
    <p-button label="Cancel" icon="pi pi-times" text (click)="confirmInvoiceDialogVisible = false"></p-button>
    <p-button label="OK" icon="pi pi-check" (click)="confirmAndGenerateInvoice()"></p-button>
</ng-template>
</p-dialog>
<p-dialog [(visible)]="sendPreviewMailDialogVisible" [style]="{ width: '420px' }" header="Send preview on mail" [modal]="true" (onHide)="sendPreviewMailDialogVisible = false">
    <ng-template pTemplate="content">
        <div class="flex flex-col gap-3">
            <p *ngIf="hasCustomerEmailFromApi" class="mb-2">
                Sending mail to <strong>{{ sendPreviewMailTo }}</strong>. Please confirm or change the email below.
            </p>
            <p *ngIf="!hasCustomerEmailFromApi" class="mb-2">
                Mail id not found for customer. Please enter email.
            </p>
            <label for="previewMailTo">Recipient email</label>
            <input id="previewMailTo" type="email" pInputText [(ngModel)]="sendPreviewMailTo" placeholder="email@example.com" class="w-full" />
        </div>
    </ng-template>
    <ng-template pTemplate="footer">
        <p-button label="Cancel" icon="pi pi-times" text (click)="sendPreviewMailDialogVisible = false"></p-button>
        <p-button label="Send" icon="pi pi-envelope" (click)="sendPreviewOnMail()" [loading]="sendPreviewMailLoading"></p-button>
    </ng-template>
    </p-dialog>
<p-toast />
<p-confirmDialog />
<p-dialog
    [(visible)]="creditLimitProceedDialogVisible"
    [modal]="true"
    [style]="{ width: '26rem' }"
    styleClass="credit-limit-dialog"
    [closable]="true"
    (onHide)="onCreditLimitProceedCancel()"
>
    <ng-template pTemplate="header">
        <span *ngIf="creditLimitDialogKind === 'overdue'" class="credit-limit-dialog-header credit-limit-dialog-header--exceeded">
            <i class="pi pi-exclamation-triangle" aria-hidden="true"></i>
            <span>Overdue Balance</span>
        </span>
        <span *ngIf="creditLimitDialogKind === 'both'" class="credit-limit-dialog-header credit-limit-dialog-header--exceeded">
            <i class="pi pi-exclamation-triangle" aria-hidden="true"></i>
            <span>Credit Limit 3 &amp; 4 Exceeded</span>
        </span>
        <span *ngIf="creditLimitDialogKind === 'exposure'" class="credit-limit-dialog-header credit-limit-dialog-header--warning">
            <i class="pi pi-exclamation-circle" aria-hidden="true"></i>
            <span>Credit Limit Warning</span>
        </span>
    </ng-template>
    <app-credit-limit-dialog-content
        [kind]="creditLimitDialogKind"
        [data]="creditLimitDialogData"
        [nood]="creditLimitDialogNood"
        [odud]="creditLimitDialogOdud"
        [note]="creditLimitProceedNote"
    ></app-credit-limit-dialog-content>
    <div class="credit-limit-approval-reason mt-3">
        <label for="previewCreditLimitApprovalReason" class="block mb-2 font-medium">Approval reason (required)</label>
        <textarea
            id="previewCreditLimitApprovalReason"
            pTextarea
            rows="3"
            class="w-full"
            [(ngModel)]="creditLimitApprovalReason"
            [disabled]="creditLimitApprovalSubmitting"
            placeholder="Enter reason for releasing credit restriction"
        ></textarea>
        <small class="text-color-secondary">Minimum 5 characters.</small>
    </div>
    <ng-template pTemplate="footer">
        <p-button label="Cancel" icon="pi pi-times" severity="secondary" [disabled]="creditLimitApprovalSubmitting" (onClick)="onCreditLimitProceedCancel()"></p-button>
        <p-button
            label="Approve &amp; Continue"
            icon="pi pi-arrow-right"
            [loading]="creditLimitApprovalSubmitting"
            [disabled]="!canSubmitCreditLimitApproval"
            (onClick)="onCreditLimitProceedAccept()"
        ></p-button>
    </ng-template>
</p-dialog>
<p-dialog
    [(visible)]="creditLimitBlockedDialogVisible"
    [modal]="true"
    [style]="{ width: '26rem' }"
    styleClass="credit-limit-dialog"
    [closable]="true"
    (onHide)="onCreditLimitBlockedDialogClose()"
>
    <ng-template pTemplate="header">
        <span *ngIf="creditLimitDialogKind === 'overdue'" class="credit-limit-dialog-header credit-limit-dialog-header--exceeded">
            <i class="pi pi-exclamation-triangle" aria-hidden="true"></i>
            <span>Overdue Balance</span>
        </span>
        <span *ngIf="creditLimitDialogKind === 'both'" class="credit-limit-dialog-header credit-limit-dialog-header--exceeded">
            <i class="pi pi-exclamation-triangle" aria-hidden="true"></i>
            <span>Credit Limit 3 &amp; 4 Exceeded</span>
        </span>
        <span *ngIf="creditLimitDialogKind === 'exposure'" class="credit-limit-dialog-header credit-limit-dialog-header--exceeded">
            <i class="pi pi-exclamation-triangle" aria-hidden="true"></i>
            <span>Credit Limit Exceeded</span>
        </span>
    </ng-template>
    <app-credit-limit-dialog-content
        [kind]="creditLimitDialogKind"
        [data]="creditLimitDialogData"
        [nood]="creditLimitDialogNood"
        [odud]="creditLimitDialogOdud"
        [note]="creditLimitBlockedNote"
    ></app-credit-limit-dialog-content>
    <ng-template pTemplate="footer">
        <p-button label="OK" icon="pi pi-check" (onClick)="onCreditLimitBlockedDialogClose()"></p-button>
    </ng-template>
</p-dialog>
<p-dialog
    [(visible)]="marginApprovalProceedDialogVisible"
    [modal]="true"
    [style]="{ width: '440px', maxWidth: '95vw' }"
    styleClass="margin-validation-dialog margin-approval-dialog"
    [closable]="true"
    (onHide)="onMarginApprovalProceedCancel()"
>
    <ng-template pTemplate="header">
        <span class="margin-dialog-header">
            <i class="pi pi-exclamation-triangle" aria-hidden="true"></i>
            <span>Margin Approval Required</span>
        </span>
    </ng-template>
    <app-margin-approval-dialog-content
        mode="approval"
        [failingLines]="marginApprovalSummary?.failingLines ?? []"
        [orderViolation]="marginApprovalSummary?.orderViolation ?? null"
        [note]="marginApprovalContactNote"
        [contactEmails]="marginApprovalContactEmails"
        [proceedActionLabel]="marginApprovalProceedLabel"
        [proceedNote]="marginApprovalProceedNote"
    ></app-margin-approval-dialog-content>
    <div class="credit-limit-approval-reason mt-3">
        <label for="marginApprovalReasonPreview" class="block mb-2 font-medium">Approval reason (required)</label>
        <textarea
            id="marginApprovalReasonPreview"
            pTextarea
            rows="3"
            class="w-full"
            [(ngModel)]="marginApprovalReason"
            [disabled]="marginApprovalSubmitting"
            placeholder="Enter reason for approving margin exception"
        ></textarea>
        <small class="text-color-secondary">Minimum 5 characters.</small>
    </div>
    <ng-template pTemplate="footer">
        <p-button label="Cancel" icon="pi pi-times" severity="secondary" [disabled]="marginApprovalSubmitting" (onClick)="onMarginApprovalProceedCancel()"></p-button>
        <p-button [label]="marginApprovalProceedLabel" icon="pi pi-check" styleClass="margin-dialog-ok-btn" [loading]="marginApprovalSubmitting" [disabled]="!canSubmitMarginApproval" (onClick)="onMarginApprovalProceedAccept()"></p-button>
    </ng-template>
</p-dialog>
<p-dialog
    [(visible)]="marginApprovalBlockedDialogVisible"
    [modal]="true"
    [style]="{ width: '440px', maxWidth: '95vw' }"
    styleClass="margin-validation-dialog margin-blocked-approval-dialog"
    [closable]="true"
    (onHide)="onMarginApprovalBlockedDialogDismiss()"
>
    <ng-template pTemplate="header">
        <span class="margin-dialog-header">
            <i class="pi pi-exclamation-triangle" aria-hidden="true"></i>
            <span>Approval Required</span>
        </span>
    </ng-template>
    <app-margin-approval-dialog-content
        mode="blocked"
        [failingLines]="marginApprovalSummary?.failingLines ?? []"
        [orderViolation]="marginApprovalSummary?.orderViolation ?? null"
        [note]="marginApprovalContactNote"
        [contactEmails]="marginApprovalContactEmails"
        [blockedApprovalNotice]="marginApprovalBlockedNotice"
    ></app-margin-approval-dialog-content>
    <ng-template pTemplate="footer">
        <p-button label="OK" icon="pi pi-check" styleClass="margin-dialog-ok-btn" (onClick)="onMarginApprovalBlockedDialogOk()"></p-button>
    </ng-template>
</p-dialog>
<div #invoice>
<div class="invoice-wrapper print-page" 
     [class.preview-mode]="isPreviewMode"
     [class.last-page]="i === paginatedContent.length - 1 && !summaryOnExtraPage"
     *ngFor="let pageLines of paginatedContent; let i = index"
     >
    <!-- Header -->
     <div #header class="header-top avoid-break">
            <img [src]="headerImage" class="logo" />
          </div>

    <!-- Main Content -->
    <div class="main-content avoid-break">
        <!-- Preview watermark only on this table area; watermark-footer below stays unchanged -->
        <div class="preview-table-area" [class.preview-page]="isPreviewMode">
        <div #mainContent class="address-invoice-row">
            <div class="address-block">
                <div>{{ item?.customerName }}</div>
                <div *ngFor="let line of getAddressLines(customerDetails.CUA1)">
                    {{ line }}
                </div>
                <div *ngFor="let phone of getPhoneLines(customerDetails.phoneNumber)">
    {{ phone }}
</div>
            </div>
            <div class="order-confirmation-label" *ngIf="isPreviewMode">Order confirmation</div>
            <div class="invoice-block">
                <div class="invoice-title">
                    <!-- <b>{{ getLabel('invoiceTitle') }}</b> -->
                </div>
                <table>
                    <tr>
                        <td>{{ getLabel('invoiceNo') }}</td>
                        <td>:</td>
                        <td>{{ isPreviewMode ? (getLabel('preview') || 'Preview') : (invoiceDetails.invoiceNo || '') }}</td>
                    </tr>
                    <tr>
                        <td>{{ getLabel('customerNo') }}</td>
                        <td>:</td>
                        <td>{{ invoiceDetails.customerNo }}</td>
                    </tr>
                    <tr>
                        <td>{{ getLabel('date') }}</td>
                        <td>:</td>
                        <td>{{ invoiceDetails.date }}</td>
                    </tr>
                    <tr>
                        <td>{{ getLabel('orderNumber') }}</td>
                        <td>:</td>
                        <td>{{ invoiceDetails.orderNumber }}</td>
                    </tr>
                    <tr *ngIf="isPreviewMode && invoiceDetails.userIdResponsible">
                        <td>{{ getLabel('salesPerson') }}</td>
                        <td>:</td>
                        <td>{{ invoiceDetails.userIdResponsible }}</td>
                    </tr>
                    <tr>
                        <td>{{ getLabel('referenceOrderNumber') }}</td>
                        <td>:</td>
                        <td>{{ isPreviewMode ? (getLabel('preview') || 'Preview') : (invoiceDetails.referenceOrderNumber || '') }}</td>
                    </tr>
                </table>
            </div>
        </div>

        <div class="prepost-block" *ngFor="let text of pageHeaderPres(pageLines)">
          <span class="prepost-block__label">Pre:</span>{{ text }}
        </div>

        <table #itemsTable class="items-table" >
            <thead>
                <tr>
                    <th [innerHTML]="getLabel('position')"></th>
                    <th [innerHTML]="getLabel('itemNo')"></th>
                    <th [innerHTML]="getLabel('quantity')"></th>
                    <th [innerHTML]="getLabel('description')"></th>
                    <th [innerHTML]="getLabel('pcs')"></th>
                    <th [innerHTML]="getLabel('size')"></th>
                    <th [innerHTML]="getLabel('price')"></th>
                    <th [innerHTML]="getLabel('discount')"></th>
                    <th [innerHTML]="getLabel('ppu')"></th>
                    <th [innerHTML]="getLabel('amount')"></th>
                </tr>
            </thead>
            <tbody>
                <ng-container *ngFor="let row of pageTableRows(pageLines)">
                    <tr *ngIf="row.kind === 'item'">
                        <td>{{ row.line.position }}</td>
                        <td>{{ row.line.itemNo }}</td>
                        <td>{{ row.line.quantity }}</td>
                        <td>{{ row.line.description }}</td>
                        <td>{{ row.line.pcs }}</td>
                        <td class="size-cell">{{ row.line.size }}</td>
                        <td>{{ row.line.salesPrice | number: '1.2-2' }}</td>
                        <td>{{ row.line.discountPercent ? (row.line.discountPercent | number: '1.2-2') : '' }}</td>
                        <td>{{ row.line.ppu | number: '1.2-2' }}</td>
                        <td>{{ row.line.lineTotalExVat | number: '1.2-2' }}</td>
                    </tr>
                    <tr *ngIf="row.kind === 'linePre'" class="prepost-row prepost-row--pre">
                        <td colspan="10"><span class="prepost-block__label">Pre:</span>{{ row.text }}</td>
                    </tr>
                    <tr *ngIf="row.kind === 'linePost'" class="prepost-row prepost-row--post">
                        <td colspan="10"><span class="prepost-block__label">Post:</span>{{ row.text }}</td>
                    </tr>
                </ng-container>
            </tbody>
        </table>

        <div class="prepost-block" *ngFor="let text of pageHeaderPosts(pageLines)">
          <span class="prepost-block__label">Post:</span>{{ text }}
        </div>

        <!-- Summary inside last page if !summaryOnExtraPage -->
        <ng-container *ngIf="i === paginatedContent.length - 1 && !summaryOnExtraPage">
            <div #summaryDiv class="Summary avoid-break" style="width: 100%;">
<div style="display: flex; width: 100%; align-items: flex-start;">
    <!-- Ident Numbers & Notice Block (left side) -->
    <div class="ident-numbers-table-wrapper" style="min-width: 260px;">
        <table class="ident-numbers-table">
            <tbody>
                <tr>
                    <td>{{ getLabel('supplierIdentNo') }}</td>
                    <td>{{ supplierDetails.supplerVrno }}</td>
                </tr>
                <tr>
                    <td>{{ getLabel('customerIdentNo') }}</td>
                    <td>{{ customerDetails.customerVrno }}</td>
                </tr>
                <tr>
                    <td>{{ getLabel('grossWeight') }}</td>
                    <td>{{ summary.totalGrossWeight | number: '1.2-2' }}</td>
                </tr>
            </tbody>
        </table>
        <div class="atradius-notice-row" *ngIf="div1 === '400'">
            <div class="atradius-notice-box">
                <div>Wij zijn verplicht<br>
                achterstallige posten<br>
                ter incasso aan<br>
                Alliance over te dragen
                </div>
                <div class="atradius-logo">Alliance</div>
            </div>
            <div class="atradius-notice-box">
                <div>We are obliged<br>
                to refer overdue<br>
                invoices to Alliance<br>
                for collection
                </div>
                <div class="atradius-logo">Alliance</div>
            </div>
        </div>
    </div>
    <!-- Summary Block (right side) -->
    <div class="invoice-summary-table-wrapper" style="margin-left: auto; max-width: 340px;">
        <table class="invoice-summary-table" style="border-collapse: collapse; width: 100%;">
            <tbody>
                <tr>
                    <td style="text-align: right; font-weight: bold;">{{ getLabel('grossValue') }}:</td>
                    <td style="text-align: right;">{{ summary.grossValue | number: '1.2-2' }}</td>
                </tr>
                <tr>
                    <td style="text-align: right; font-weight: bold;">{{ getLabel('totalDiscountValue') }}:</td>
                    <td style="text-align: right;">{{ summary.totalDiscountValue | number: '1.2-2' }}</td>
                </tr>
                <tr>
                    <td style="text-align: right; font-weight: bold;">{{ getLabel('netAmount') }}:</td>
                    <td style="text-align: right;">{{ summary.netAmount | number: '1.2-2' }}</td>
                </tr>
                <tr>
                    <td style="vertical-align: top; padding-top: 10px;" colspan="2">
                        <table style="border-collapse: collapse; font-size: 10px; width: 100%;">
                            <thead>
                                <tr>
                                    <th style="text-align: left">{{ getLabel('vatPercentLabel') }}</th>
                                    <th style="text-align: left">{{ getLabel('taxBaseLabel') }}</th>
                                    <th style="text-align: left">{{ getLabel('vatAmountLabel') }}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let vat of summary.vatSummaries">
                                    <td>{{ vat.vatPercentage | number: '1.2-2' }}</td>
                                    <td>{{ vat.totalNetAmount | number: '1.2-2' }}</td>
                                    <td>{{ vat.totalVatAmount | number: '1.2-2' }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </td>
                </tr>
                <tr>
                    <td style="text-align: right; font-weight: bold;">{{ getLabel('orderValue') }}:</td>
                    <td style="text-align: right;"><strong>{{ summary.totalOrderValue | number: '1.2-2' }}</strong></td>
                </tr>
            </tbody>
        </table>
    </div>
</div>
</div>
        </ng-container>
        </div>
        <!-- watermark-footer unchanged: no preview styling -->
        <div class="watermark-footer">
            <img src="assets/torna_logo.png" alt="Watermark" />
        </div>
    </div>

    <!-- Footer on every page -->
       <div #footer class="footer avoid-break">
            <img [src]="footerImage" class="footer-logo" />
          </div>
</div>
<!-- Summary on extra page if needed -->
<div *ngIf="summaryOnExtraPage">
    <div class="invoice-wrapper print-page last-page" 
         [class.preview-mode]="isPreviewMode"
         style="display: flex; flex-direction: column; min-height: 297mm;">
    <!-- Header -->
    <div #header class="header-top avoid-break">
            <img [src]="headerImage" class="logo" />
          </div>
    <!-- Main Content -->
    <div class="main-content avoid-break" style="flex: 1 0 auto;">
        <div class="preview-table-area preview-table-area--extra" [class.preview-page]="isPreviewMode">
        <div class="Summary avoid-break" style="width: 100%;">
            <div style="display: flex; width: 100%; align-items: flex-start;">
                <!-- Ident Numbers & Notice Block (left side) -->
                <div class="ident-numbers-table-wrapper" style="min-width: 260px;">
                    <table class="ident-numbers-table">
                        <tbody>
                            <tr>
                                <td>{{ getLabel('supplierIdentNo') }}</td>
                                <td>{{ supplierDetails.supplerVrno }}</td>
                            </tr>
                            <tr>
                                <td>{{ getLabel('customerIdentNo') }}</td>
                                <td>{{ customerDetails.customerVrno }}</td>
                            </tr>
                            <tr>
                                <td>{{ getLabel('grossWeight') }}</td>
                                <td>{{ summary.totalGrossWeight | number: '1.2-2' }}</td>
                            </tr>
                        </tbody>
                    </table>
                    <div class="atradius-notice-row" *ngIf="div1 === '400'">
                        <div class="atradius-notice-box">
                            <div>Wij zijn verplicht<br>
                            achterstallige posten<br>
                            ter incasso aan<br>
                            Alliance over te dragen
                            </div>
                            <div class="atradius-logo">Alliance</div>
                        </div>
                        <div class="atradius-notice-box">
                            <div>We are obliged<br>
                            to refer overdue<br>
                            invoices to Alliance<br>
                            for collection
                            </div>
                            <div class="atradius-logo">Alliance</div>
                        </div>
                    </div>
                </div>
                <!-- Summary Block (right side) -->
                <div class="invoice-summary-table-wrapper" style="margin-left: auto; max-width: 340px;">
                    <table class="invoice-summary-table" style="border-collapse: collapse; width: 100%;">
                        <tbody>
                            <tr>
                                <td style="text-align: right; font-weight: bold;">{{ getLabel('grossValue') }}:</td>
                                <td style="text-align: right;">{{ summary.grossValue | number: '1.2-2' }}</td>
                            </tr>
                            <tr>
                                <td style="text-align: right; font-weight: bold;">{{ getLabel('totalDiscountValue') }}:</td>
                                <td style="text-align: right;">{{ summary.totalDiscountValue | number: '1.2-2' }}</td>
                            </tr>
                            <tr>
                                <td style="text-align: right; font-weight: bold;">{{ getLabel('netAmount') }}:</td>
                                <td style="text-align: right;">{{ summary.netAmount | number: '1.2-2' }}</td>
                            </tr>
                            <tr>
                                <td style="vertical-align: top; padding-top: 10px;" colspan="2">
                                    <table style="border-collapse: collapse; font-size: 10px; width: 100%;">
                                        <thead>
                                            <tr>
                                                <th style="text-align: left">{{ getLabel('vatPercentLabel') }}</th>
                                                <th style="text-align: left">{{ getLabel('taxBaseLabel') }}</th>
                                                <th style="text-align: left">{{ getLabel('vatAmountLabel') }}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr *ngFor="let vat of summary.vatSummaries">
                                                <td>{{ vat.vatPercentage | number: '1.2-2' }}</td>
                                                <td>{{ vat.totalNetAmount | number: '1.2-2' }}</td>
                                                <td>{{ vat.totalVatAmount | number: '1.2-2' }}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </td>
                            </tr>
                            <tr>
                                <td style="text-align: right; font-weight: bold;">{{ getLabel('orderValue') }}:</td>
                                <td style="text-align: right;"><strong>{{ summary.totalOrderValue | number: '1.2-2' }}</strong></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        </div>
        <div class="watermark-footer">
            <img src="assets/torna_logo.png" alt="Watermark" />
        </div>
    </div>
    <!-- Footer OUTSIDE main-content, always at the bottom -->
        <div #footer class="footer avoid-break">
            <img [src]="footerImage" class="footer-logo" />
          </div>
</div>
</div>
<p-dialog header="Already Synced"
          [(visible)]="alreadySyncedDialogVisible"
          [modal]="true"
          [dismissableMask]="false"
          [style]="{ width: '400px'}"
          contentStyle="padding:0; display:flex; align-items:center; gap:12px; overflow:visible;">
    <ng-template pTemplate="content">
        <div style="display:flex; align-items:center; gap:12px; width:100%;">
            <i class="pi pi-info-circle" style="font-size:1.8rem; flex:0 0 auto;"></i>
            <div style="font-size:16px; padding-right:8px; flex:1 1 auto; word-break:break-word;">
                {{ alreadySyncedDialogMessage }}
            </div>
        </div>
    </ng-template>
    <ng-template pTemplate="footer">
        <p-button label="OK" icon="pi pi-check" styleClass="p-button-sm" (click)="alreadySyncedDialogVisible = false"></p-button>
    </ng-template>
</p-dialog>
<p-dialog header="Customer blocked"
          [(visible)]="customerBlockedDialogVisible"
          [modal]="true"
          [dismissableMask]="false"
          [style]="{ width: '400px'}"
          contentStyle="padding:0; display:flex; align-items:center; gap:12px; overflow:visible;">
    <ng-template pTemplate="content">
        <div style="display:flex; align-items:center; gap:12px; width:100%;">
            <i class="pi pi-ban" style="font-size:1.8rem; flex:0 0 auto; color:#c62828;"></i>
            <div style="font-size:16px; padding-right:8px; flex:1 1 auto; word-break:break-word;">
                {{ customerBlockedDialogMessage }}
            </div>
        </div>
    </ng-template>
    <ng-template pTemplate="footer">
        <p-button label="OK" icon="pi pi-check" styleClass="p-button-sm" (click)="customerBlockedDialogVisible = false"></p-button>
    </ng-template>
</p-dialog>